export default "__VITE_ASSET__DsQAQy7g__"